import { Router, Response } from 'express';
import { authMiddleware, AuthRequest } from '../../middleware/auth.middleware';
import { AccessToken, TrackSource } from 'livekit-server-sdk';
import { env } from '../../config/env';
import { AppError } from '../../shared/errors/AppError';

const router = Router();

router.get('/token', authMiddleware, async (req: AuthRequest, res: Response, next) => {
  try {
    const room = req.query.room as string;
    if (!room) {
      throw new AppError(400, 'Room name is required');
    }

    const userId = req.user?.sub;
    const username = req.user?.username || userId;

    if (!userId) {
      throw new AppError(401, 'Unauthorized');
    }

    const token = new AccessToken(
      process.env.LIVEKIT_API_KEY || env.LIVEKIT_API_KEY || 'devkey',
      process.env.LIVEKIT_API_SECRET || env.LIVEKIT_API_SECRET || 'secret',
      {
        identity: userId,
        name: username,
      }
    );

    token.addGrant({
      roomJoin: true,
      room: room,
      canPublish: true,
      canSubscribe: true,
      canPublishData: true,
    });

    const jwt = await token.toJwt();

    let livekitUrl = process.env.LIVEKIT_URL || env.LIVEKIT_URL || 'ws://localhost:7880';
    if (livekitUrl.includes('localhost') || livekitUrl.includes('127.0.0.1')) {
      const clientHost = req.hostname || (req.headers.host ? req.headers.host.split(':')[0] : 'localhost');
      if (clientHost && clientHost !== 'localhost' && clientHost !== '127.0.0.1') {
        livekitUrl = `ws://${clientHost}:7880`;
      }
    }

    res.json({
      success: true,
      token: jwt,
      livekitUrl,
    });
  } catch (err) {
    next(err);
  }
});

export default router;
